import React, { useCallback, useEffect } from "react"
import { Container } from "reactstrap"
import Header from "./Header"
import Footer from "./Footer.hbd"
import { throttle } from "lodash"

const Layout = ({ children }) => {
  useReadComicsFloatingButtonExtraSpace()
  return (
    <>
      <Header />
      <Container className="hbd-content-container main-main">{children}</Container>
      <Footer />
    </>
  )
}

function useReadComicsFloatingButtonExtraSpace() {
  const bottomForegroundHeight = 100
  const updateExtraSpace = useCallback(
    throttle(() => {
      const scrollPosition = window.scrollY + window.innerHeight
      const documentHeight = document.documentElement.scrollHeight
      const distanceFromBottom = documentHeight - scrollPosition
      const extraSpaceToAdd = Math.max(bottomForegroundHeight - distanceFromBottom, 0)
      document.body.style.setProperty(
        "--read-comics-floating-button-extra-space",
        `${extraSpaceToAdd}px`
      )
    }, 30),
    []
  )

  useEffect(() => {
    updateExtraSpace()
    window.addEventListener("scroll", updateExtraSpace)
    return () => {
      window.removeEventListener("scroll", updateExtraSpace)
      updateExtraSpace.cancel()
    }
  }, [])
}

export default Layout
